<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>智能人事</Breadcrumb-item>
        <Breadcrumb-item>员工关系</Breadcrumb-item>
        <Breadcrumb-item>入职管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <Alert type="warning" show-icon class="tip">
      数据从钉钉同步到本后台；在本后台新增或修改不会写回钉钉。本页不含二维码邀请与欢迎公告。
    </Alert>
    
    <div class="search">
      <Form inline :label-width="60" :show-message="false">
        <Form-item label="状态">
          <Select v-model="query.status" style="width:140px;" clearable @on-change="search">
            <Option value="PENDING">待入职</Option>
            <Option value="DONE">已入职</Option>
            <Option value="CANCEL">已取消</Option>
          </Select>
        </Form-item>
        <Form-item label="关键字">
          <Input v-model="query.keyword" placeholder="姓名/手机" style="width:180px;" @on-enter="search"/>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="search">查询</Button>
        </Form-item>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" :loading="syncing" @click="doSync">从钉钉同步</Button>
      <Button style="margin-left:8px;" type="success" @click="showAdd=true">添加待入职</Button>
    </div>
    <Table :columns="columns" :data="rows" :loading="loading" stripe no-data-text="暂无待入职"></Table>
    <div style="margin-top:12px;text-align:right;">
      <Page :total="total" :current="query.pageIndex" :page-size="query.pageSize"
            show-total @on-change="p => { query.pageIndex=p; load() }"/>
    </div>

    <Modal v-model="showAdd" title="添加待入职（仅本地）" @on-ok="addRow">
      <Form :label-width="90">
        <Form-item label="姓名" required><Input v-model="form.name"/></Form-item>
        <Form-item label="手机" required><Input v-model="form.mobile"/></Form-item>
        <Form-item label="预计入职"><DatePicker v-model="form.preEntryTime" type="datetime" style="width:100%;"/></Form-item>
        <Form-item label="备注"><Input v-model="form.remark" type="textarea"/></Form-item>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { onboardingStatusText, sourceText } from './enumLabels'
export default {
  name: 'SmartHrOnboarding',
  data () {
    return {
      loading: false, syncing: false, showAdd: false,
      rows: [], total: 0,
      query: { pageIndex: 1, pageSize: 20, status: 'PENDING', keyword: '' },
      form: { name: '', mobile: '', preEntryTime: null, remark: '' },
      columns: [
        { title: 'ID', key: 'id', width: 80 },
        { title: '姓名', key: 'name', minWidth: 120 },
        { title: '手机', key: 'mobile', minWidth: 120 },
        { title: '预计入职', key: 'preEntryTime', minWidth: 160 },
        { title: '状态', key: 'status', width: 100,
          render: (h, { row }) => h('span', onboardingStatusText(row.status)) },
        { title: '来源', key: 'source', width: 90,
          render: (h, { row }) => h('span', sourceText(row.source)) },
        { title: '备注', key: 'remark', minWidth: 140 }
      ]
    }
  },
  created () { this.load() },
  methods: {
    stripReadonlyTimes (obj) {
      if (!obj || typeof obj !== 'object') return obj
      const payload = Object.assign({}, obj)
      delete payload.gmtCreate
      delete payload.gmtModified
      delete payload.syncedAt
      return payload
    },
    search () { this.query.pageIndex = 1; this.load() },
    load () {
      this.loading = true
      this.$http.post('/smartHr/onboarding/page', this.query).then(res => {
        if (res && res.status === 'ok' && res.data) {
          this.rows = res.data.data || []
          this.total = res.data.totalCount || 0
        }
      }).finally(() => { this.loading = false })
    },
    doSync () {
      this.syncing = true
      this.$http.post('/smartHr/sync', { scope: 'onboarding', mode: 'full' }).then(() => {
        this.$Message.success('已触发同步')
        this.load()
      }).finally(() => { this.syncing = false })
    },
    addRow () {
      if (!this.form.name || !this.form.mobile) {
        this.$Message.warning('姓名和手机必填')
        return
      }
      const payload = this.stripReadonlyTimes(this.form)
      if (payload.preEntryTime instanceof Date) {
        payload.preEntryTime = this.formatDate(payload.preEntryTime)
      }
      this.$http.post('/smartHr/onboarding/add', payload).then(res => {
        if (res && res.status === 'ok') {
          this.$Message.success('已添加（仅本地）')
          this.showAdd = false
          this.form = { name: '', mobile: '', preEntryTime: null, remark: '' }
          this.load()
        }
      })
    },
    formatDate (d) {
      const pad = n => (n < 10 ? '0' + n : '' + n)
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' '
        + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds())
    }
  }
}
</script>
<style scoped>
.tip { margin-bottom: 12px; }
.btn-wrap {
  margin: 8px 0 12px;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// SmartHrOnboarding.vue?5884a816